import {
  GetMyProfileUrl,
  GetProfileId,
  PostProfileMedia,
  DeleteProfileMediaByIndex,
  LastUpdatedTimestampUrl,
  GetNoteUrl,
  // DeleteNote,
  UpdateNote
} from '../utils/profileUrls'
import {
  genericPutRequestToApi,
  genericPostRequestToApi,
  genericDeleteRequestToApi,
  genericGetRequestToApi
} from '../utils/genericRequests'
import moment from 'moment'

const requestLastUpdatedTimestamp = profileId => {
  return genericGetRequestToApi(LastUpdatedTimestampUrl(profileId))
}

/**
 * Updates user`s profile
 * @param {Profile} data - user Profile
 */
const updateMyProfile = data => {
  return genericPutRequestToApi(GetMyProfileUrl(), data)
}
const updateProfileById = (profileId, data) => {
  return genericPutRequestToApi(GetProfileId(profileId), data)
}
const uploadProfileMedia = (profileId, category, label, data) => {
  return genericPostRequestToApi(
    PostProfileMedia(profileId, category, label),
    data
  )
}
const updateProfileNote = (profileId, data) => {
  return genericPostRequestToApi(GetNoteUrl(), profileId, data)
}

const removeProfileMediaByIndex = (profileId, index) => {
  return genericDeleteRequestToApi(DeleteProfileMediaByIndex(profileId, index))
}
// const removeNoteById = (noteId) => {
//   return genericDeleteRequestToApi(DeleteNote(noteId))
// }
const updateNoteById = (noteId, data) => {
  return genericPutRequestToApi(UpdateNote(noteId), data)
}

const uploadNewAvatar = async (profile, data) => {
  const oldAvatar = profile.media
    ? profile.media.find(item => item.type === 'avatar')
    : undefined
  let updatedProfile = (
    await uploadProfileMedia(profile._id, 'avatar', 'avatar', data)
  ).data
  if (oldAvatar) {
    updatedProfile = await removeAvatar(updatedProfile)
  }
  return updatedProfile
}
const removeAvatar = async (profile) => {
  const oldAvatar = profile.media
    ? profile.media.find(item => item.type === 'avatar')
    : undefined
  const oldAvatarIndex = profile.media.findIndex(
    item => item.type === oldAvatar.type && item.link === oldAvatar.link
  )
  const updatedProfile = (
    await removeProfileMediaByIndex(profile._id, oldAvatarIndex)
  ).data
  return updatedProfile
}

const uploadDocument = async (profile, index, label, data) => {
  let updatedDocuments = (
    await uploadProfileMedia(profile._id, 'user_documents', label, data)
  ).data
  return updatedDocuments
}

const removeDocument = async (profile, data) => {
  const oldDocumentIndex = profile.media.findIndex(
    item => item.type === data.type && item.link === data.link
  )
  let updatedDocuments = (
    await removeProfileMediaByIndex(profile._id, oldDocumentIndex)
  ).data
  return updatedDocuments
}
const uploadLogo = async (profile, label, data) => {
  let oldLogo = profile.media
    ? profile.media.find(item => item.type === 'logo')
    : undefined
  let updatedProfile = (await uploadProfileMedia(profile._id, 'logo', label, data))
    .data
  if (oldLogo) {
    const oldLogoIndex = updatedProfile.media.findIndex(
      item => item.type === oldLogo.type && item.link === oldLogo.link
    )
    updatedProfile = (await removeProfileMediaByIndex(updatedProfile._id, oldLogoIndex))
      .data
  }
  return updatedProfile
}
const removeLogo = async (profile, data) => {
  const oldLogoIndex = profile.media.findIndex(
    item => item.type === data.type && item.link === data.link
  )
  let updatedLogo = (await removeProfileMediaByIndex(profile._id, oldLogoIndex))
    .data
  return updatedLogo
}

const setProfileLastUpdatedTimestamp = async profileData => {
  const timestampUpdate = await requestLastUpdatedTimestamp(profileData._id)
  const lastUpdatedTime = timestampUpdate.data.lastUpdated

  if (!profileData.lastUpdated) {
    return {
      updatedData: { ...profileData, lastUpdated: lastUpdatedTime },
      updated: true
    }
  }

  const profileTimestamp = profileData.lastUpdated
  const secondsDiff = parseInt(
    moment
      .duration(moment(lastUpdatedTime).diff(moment(profileTimestamp)))
      .asSeconds()
  )
  if (secondsDiff > 0) {
    return {
      updatedData: { ...profileData, lastUpdated: lastUpdatedTime },
      updated: true
    }
  }
  return { updatedData: profileData, updated: false }
}

const updateNote = async (agentProfile, clientProfile, data) => {
  const oldNote = agentProfile.notes.find(item => item.refUserId === clientProfile._id)
  const noteBody = {
    refUserId: clientProfile._id,
    message: data
  }
  if (oldNote) {
    const updatedNote = (await updateNoteById(oldNote._id, noteBody)).data
    return updatedNote
  } else {
    const newNote = (await updateProfileNote(noteBody)).data
    return newNote
  }
}

export {
  requestLastUpdatedTimestamp,
  uploadNewAvatar,
  removeAvatar,
  updateMyProfile,
  updateProfileById,
  uploadDocument,
  uploadProfileMedia,
  removeDocument,
  removeProfileMediaByIndex,
  uploadLogo,
  removeLogo,
  setProfileLastUpdatedTimestamp,
  updateNote
}
